import { isDate, parse } from 'date-fns'
import * as yup from 'yup'
import { getAcceptedAges } from '../components/Questions/PersonalDetailsQuestion/acceptedAges'
import { ApplicationFormAnswers } from '../components/ApplicationForm/ApplicationFormContext'
import BaseValidator from './BaseValidator'
import { AttributionDetails } from '../components/ApplicationForm/types'

const DateOfBirthValidator = ({ source }: Partial<AttributionDetails>): BaseValidator => {
  const dateNow = new Date()
  const maxAgeNumber = getAcceptedAges(source)
  const maxYear = new Date(dateNow.setFullYear(dateNow.getFullYear() - maxAgeNumber))
  const minYear = new Date('01/01/1901')

  function parseDateString(_: string, originalValue: string) {
    const parsedDate = isDate(originalValue)
      ? originalValue
      : parse(originalValue, 'dd-MM-yyyy', new Date())
    return parsedDate
  }

  const schema = yup.object().shape({
    dateOfBirth: yup.date().required()
      .transform(parseDateString)
      .typeError('Please enter your date of birth (DD/MM/YYYY)')
      .min(minYear, 'Please enter a year greater than 1900')
      .max(maxYear, `You must be over ${maxAgeNumber} years old to apply`)
  })

  return {
    getValidator: () => schema,
    validateState: (state: ApplicationFormAnswers) => {
      // date of birth is stored in two locations on the answers currently because experiments...
      // this function is only used with prefill so we use the value stored under personal details as that's where prefill puts it!
      const { personalDetails } = state
      const { dateOfBirth } = personalDetails ?? {}
      return schema.isValidSync({
        dateOfBirth: `${dateOfBirth?.day}-${dateOfBirth?.month}-${dateOfBirth?.year}`
      })
    }
  }
}

export default DateOfBirthValidator
